module.exports = __webpack_public_path__ + "static/img/commingsoon.7edac82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/commingsoon.png
// module id = lce/
// module chunks = 134